import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"text-none bar-8",attrs:{"outlined":"","small":"","color":"#D3D3D3"},on:{"click":ev => _vm.$emit('click', ev)}},[_c('span',{staticClass:"text-gray-1100 font-weight-regular"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }